<img class="w-12 h-12 mb-8" [src]="imagePath" alt="emoji" />
<h1 class="text-3xl sm:text-4xl mb-8 title" [innerHtml]="title"></h1>
